import React from "react";
import ReactDOM from "react-dom";

export interface SimpleCarouselPayload {
  scope: HTMLElement;
  slides: HTMLElement[];
  startAt?: number;
}

interface SimpleCarouselState {
  activeIndex: number;
}

interface SimpleCarouselProps {
  payload: SimpleCarouselPayload;
}

export class SimpleCarousel extends React.Component<SimpleCarouselProps, SimpleCarouselState> {
  get hasPrev(): boolean {
    return this.state.activeIndex - 1 >= 0;
  }

  get hasNext(): boolean {
    return this.state.activeIndex + 1 <= this.props.payload.slides.length - 1;
  }

  constructor(props: SimpleCarouselProps) {
    super(props);

    this.state = {
      activeIndex: props.payload.startAt || 0
    };
  }

  prev(): void {
    if (this.hasPrev) this.setState({ activeIndex: this.state.activeIndex - 1 });
  }

  next(): void {
    if (this.hasNext) this.setState({ activeIndex: this.state.activeIndex + 1 });
  }

  jumpTo(index: number): void {
    if (index === this.state.activeIndex) return;

    const amount = index - this.state.activeIndex;
    this.setState({ activeIndex: this.state.activeIndex + amount });
  }

  stateClasses(index: number): string {
    const classes = ["sC__itemWrap"];

    if (index === this.state.activeIndex) classes.push("sC__itemWrap--active");

    if (this.hasNext && index === this.state.activeIndex + 1) classes.push("sC__itemWrap--next");

    if (this.hasPrev && index === this.state.activeIndex - 1) classes.push("sC__itemWrap--prev");

    return classes.join(" ");
  }

  render() {
    const { activeIndex } = this.state;
    const { slides } = this.props.payload;

    return (
      <div className="sC__outerWrap">
        <div className="sC__itemsWrap" style={{ left: `${100 * activeIndex * -1}%` }}>
          {slides.map((slide, index) => {
            return (
              <div
                key={`slide${index}`}
                className={this.stateClasses(index)}
                dangerouslySetInnerHTML={{ __html: slide.outerHTML }}
              />
            );
          })}
        </div>

        <nav className="sC__nav ">
          <div
            className={`sC__navItem sC__navItem--prev ${this.hasPrev ? "" : "sC__navItem--disabled"}`}
            onClick={() => this.prev()}
          />
          <div
            className={`sC__navItem sC__navItem--next ${this.hasNext ? "" : "sC__navItem--disabled"}`}
            onClick={() => this.next()}
          />
        </nav>

        <div className="pips">
          {slides.map((slide, index) => {
            return (
              <div
                key={`pip${index}`}
                className={`pips__item ${index === this.state.activeIndex ? "pips__item--active" : ""}`}
                onClick={() => this.jumpTo(index)}
              />
            );
          })}
        </div>
      </div>
    );
  }
}
